<template>
  <b-container >
    <b-row sm="1" class="justify-content-md-center">
      <b-col md="auto">
        <h4>{{fullRace.location}} {{fullRace.formattedDate}} {{fullRace.time}}</h4>
      </b-col>
    </b-row>
    <b-row sm="1" class="justify-content-md-center">
      <RunnersTable v-if="fullRaceLoaded" :horses="fullRace.horses"/>
      <RunnersTable v-if="!fullRaceLoaded" :horses="race.horses"/>
    </b-row>
    <b-spinner v-if="!fullRaceLoaded" variant="success" label="Spinning"></b-spinner>
    <b-row  v-if="fullRaceLoaded" sm="1" class="justify-content-md-center" align-h="center">
      <b-col md="auto" align-h="center">
        <h5>Tag Table</h5>
        <h6 class="subtitle">Bold indicates above average</h6>
        <TagTable :race="fullRace"/>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import * as PredictionClient from '../clients/PredictionClient'
import Race from '../models/Race'
import RunnersTable from './RunnersTable'
import TagTable from './TagTable'
export default {
  name: 'RaceDetail',
  components: {
    RunnersTable, TagTable
  },
  props: ['race'],
  data () {
    return {
      title: 'RaceDetail',
      fullRace: {_id: undefined, date: "", location: undefined},
      fullRaceLoaded: false
    }
  },
  methods: {
    dateSelected: function(date) {
    },
    loadFullRace: function (race) {
      return PredictionClient.getPrediction(race._id, true)
      .then(race => {
        this.fullRace = new Race(race)
        this.fullRaceLoaded = true
      })
    }
  },
  mounted () {
    console.log(this.race)
    window.scrollTo(0,0);
    this.fullRace = this.race
    if (!this.fullRace._id) this.fullRace._id = this.$route.params.raceId
    if (!this.fullRace.date) this.fullRace.date = ""
    this.loadFullRace(this.fullRace)
  }
}

</script>
<style scoped>

</style>
